<mat-nav-list class="side-navbar">
  <ng-template #menuItemTemplate let-items>
    <mat-accordion [multi]="false">
      <ng-container *ngFor="let item of items">
        <ng-container *ngIf="item.children && item.children.length > 0; else singleItem">
          <mat-expansion-panel [class.mat-elevation-z0]="true">
            <mat-expansion-panel-header>
              <div class="item">
                <button mat-icon-button>
                  <mat-icon mat-list-icon>{{ item.icon }}</mat-icon>
                </button>
                <a>{{ item.text }}</a>
              </div>
            </mat-expansion-panel-header>
            <ng-container *ngTemplateOutlet="menuItemTemplate; context: { $implicit: item.children }"></ng-container>
          </mat-expansion-panel>
        </ng-container>
        <ng-template #singleItem>
          <mat-list-item
            *ngIf="item"
            class="highlighted-text"
            [routerLink]="item.routerLink"
            [routerLinkActive]="['highlight']"
            [queryParams]="item?.queryParams"
          >
            <div class="item">
              <button mat-icon-button>
                <mat-icon mat-list-icon>{{ item.icon }}</mat-icon>
              </button>
              <a>{{ item.text }}</a>
            </div>
          </mat-list-item>
        </ng-template>
      </ng-container>
    </mat-accordion>
  </ng-template>
  <ng-container *ngTemplateOutlet="menuItemTemplate; context: { $implicit: menuList }"></ng-container>
</mat-nav-list>
